import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import LoginWithPhoneUI from './LoginWithPhoneUI.js'

class LoginWithPhoneSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      successMsg: null,
      errorList: [],
      submitted: false,
      // phone
      phoneNumber: '',
      phoneNumberError: null,
      // pin
      pinCode: '',
      pinCodeError: null,
    }
  }

  render() {
    return (
      <LoginWithPhoneUI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // phoneNumber
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={this.onPhoneNumberChange}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={this.setPhoneNumberError}
        // pinCode
        pinCode={this.state.pinCode}
        onPinCodeChange={this.onPinCodeChange}
        pinCodeError={this.state.pinCodeError}
        setPinCodeError={this.setPinCodeError}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onPhoneNumberChange = (value) => {
    this.setState({phoneNumber: value})
  }

  onPinCodeChange = (event) => {
    this.setState({pinCode: event.target.value})
  }

  setPhoneNumberError = (error) => {
    this.setState({phoneNumberError: error})
  }

  setPinCodeError = (error) => {
    this.setState({pinCodeError: error})
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/pub/loginWithPhone`,
      this.onLoginCallback, {
        phoneNumber: this.state.phoneNumber,
        pinCode: this.state.pinCode
      }
    )
  }

  onLoginCallback = (response) => {
    let errorList = []
    this.setState({submitted: false})

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch(error.fieldName) {
          case 'phoneNumber':
            this.setPhoneNumberError(error.message)
            break;
          case 'pinCode':
            this.setPinCodeError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({successMsg: response.success})

    if (errorList.length === 0) {
      this.props.context.onLogin(response.session)
    }
  }

  getMessages(context) {
    let arr = [
      'c_phone_number',
      'c_pin_code',
      'c_login',
      'c_next',
      'c_forgot_pincode_help',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pub_login_w_ph', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default LoginWithPhoneSF
